import { AlgoliaService } from '@/features/session/data/algolia.service.ts'
import { initializeAlgoliaClient } from '@/features/shared/data/algolia/algolia-client.ts'

export const getAlgoliaApiKey = async (): Promise<string | undefined> => {
  const key = await AlgoliaService.getApiKey()
  initializeAlgoliaClient(key)
  return key
}
